import { InjectionToken } from '@angular/core';
import { Functions, getFunctions } from 'firebase/functions';

export const FUNCTIONS_TOKEN = new InjectionToken<Functions>('Firebase Functions', {
  providedIn: 'root',
  factory: () => getFunctions(undefined, 'asia-northeast1')
});
